import React, { useState, useEffect } from "react";
import "./CartProduct.css";
import { useStateValue } from "../../StateProvider";
import { Minus, Plus, Trash2 } from "lucide-react";
import { toast } from "react-toastify";

function CartProduct({ product_id, productName, productImage, price, category, available }) {
  const MAX_QTY = 3;
  const [{ cart }, dispatch] = useStateValue();
  const cartItem = cart.find((i) => i.id === product_id);
  const [quantity, setQuantity] = useState(cartItem?.quantity || 1);
  const isReup = category?.toLowerCase().trim() === "reup-vault";

  useEffect(() => {
    if (cartItem) setQuantity(cartItem.quantity);
  }, [cartItem]);

  const updateQty = (n) => {
    if (n < 1) {
      dispatch({ type: "REMOVE_FROM_CART", id: product_id });
    } else if (n <= MAX_QTY) {
      dispatch({ type: "UPDATE_QUANTITY", id: product_id, quantity: n });
      setQuantity(n);
    } else {
      toast.warn(`Max ${MAX_QTY} per item`, { autoClose: 1500 });
    }
  };

  const remove = () => {
    dispatch({ type: "REMOVE_FROM_CART", id: product_id });
    toast(`${productName} removed from cart!`, { autoClose: 2000 });
  };

  const lineTotal = new Intl.NumberFormat("en-NG", {
    style: "currency", currency: "NGN", minimumFractionDigits: 2,
  }).format(price * quantity);

  return (
    <div className="cp">
      <img src={productImage} alt={productName} className="cp__img" />
      <div className="cp__info">
        <p className="cp__name">{productName}</p>
        <p className="cp__price">{lineTotal}</p>
        {!isReup && available && (
          <div className="cp__stepper">
            <button className="cp__step-btn" onClick={() => updateQty(quantity - 1)}>
              <Minus size={12} />
            </button>
            <span className="cp__qty">{quantity}</span>
            <button
              className="cp__step-btn"
              onClick={() => updateQty(quantity + 1)}
              disabled={quantity >= MAX_QTY}
            >
              <Plus size={12} />
            </button>
          </div>
        )}
      </div>
      <button className="cp__remove" onClick={remove} aria-label="Remove item">
        <Trash2 size={16} />
      </button>
    </div>
  );
}

export default CartProduct;
